<mat-card appearance="outlined" class="mat-elevation-z1 mat-card-scrollable cssload-container">
    @if (personalInfo) {
        <mat-card-header>
            <mat-card-title>{{ 'PersonalInfo.Title' | translate }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <h3>{{ personalInfo.displayName }}</h3>
            <address>{{ personalInfo.correspondenceAddress }}</address>
            @for (account of personalInfo.accounts; track account.id) {
                <div class="mb-2">
                    <div class="label">{{ account.accountTypeDescription }}</div>
                    <div>
                        {{ account.traderDisplayName ? account.traderDisplayName + ', ' : '' }}{{ account.numberOfShares }}
                        {{ 'ShareStatistics.Shares' | translate }}
                    </div>
                </div>
            }
        </mat-card-content>
    } @else {
        {{ 'General.Loading' | translate }}...
    }
</mat-card>
